import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon";

const ChildAccountContents = ({ active }) => {
  const { ranking, promotion, articles } = useStaticQuery(graphql`
    query ChildAccountContents {
      ranking: mysqlRanking(mysqlId: {eq: 124}) {
        url
        prefix_url
      }

      promotion: mysqlTerms(mysqlId: {eq: 157}) {
        term_normalized
        path
      }

      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-konto-dla-dziecka"}}}},
        limit: 4
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {ranking && (<>
      <strong>Rankingi</strong>

      <Link 
        to={resolveUrl(ranking.prefix_url, ranking.url)} 
        className={["top-navigation-link", "gold", b.mt2, b.mb4].join(' ')}
      >
        {active && <span className="top-navigation-link-icon">
          <Icon icon="Ranking" size={34} />
        </span>}
       
        Ranking kont dla dzieci
      </Link>
    </>)}

    {promotion && (<>
      <strong>Promocje</strong>

      <Link
        to={resolveUrl(promotion.path, promotion.term_normalized)} 
        className={["top-navigation-link", b.mt2, b.mb4].join(' ')}
      >
        {active && <span className="top-navigation-link-icon">
          <Icon icon="Coins" size={34} />
        </span>}

        Promocje kont dla dzieci
      </Link>
    </>)}

    {active && articles.nodes.length > 0 && (<>
      <strong>Artykuły o kontach dla dzieci</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div> 
    </>)} 
  </>);
};

export default ChildAccountContents;
